import React from 'react';
import RecipeManager from '../../../recipeManager/RecipeManager';

export default function GroupRecipesPage() {
  return <RecipeManager />;
}
